import { forwardRef } from 'react';
import type { ReactNode } from 'react';
import { FeedbackAction } from './InlineAlert';
import type { Action, WithClassName } from './types';

export type EmptyStateProps = WithClassName & {
  kind: 'no-data' | 'no-matches' | 'no-changes';
  title: string;
  description: string;
  icon?: ReactNode;
  action?: Action;
  headingLevel?: 2 | 3;
};

export const EmptyState = forwardRef<HTMLDivElement, EmptyStateProps>(function EmptyState({
  kind, title, description, icon, action, headingLevel = 3, className,
}, ref) {
  const Heading = headingLevel === 2 ? 'h2' : 'h3';
  return <div ref={ref} className={`ui-empty-state ui-empty-state--${kind} ${className ?? ''}`}>
    {icon && <span className="ui-empty-state__icon" aria-hidden="true">{icon}</span>}
    <Heading className="ui-empty-state__title">{title}</Heading>
    <p>{description}</p>
    {action && <FeedbackAction action={action} />}
  </div>;
});
